<template>
  <div class="header">
    <div class="desktop-logo container">
      <div class="left">
        <a href="https://brocku.ca/ccovi/"><img class="logo" src="../assets/ccovi-logo.svg" /></a>
        <h1>TanninAlert</h1>
      </div>
      <div class="right hide-on-mobile">
        <a href="https://brocku.ca/"><img src="https://brocku.ca/wp-content/themes/brocku-mu-base/images/brocku-logo-rgb.svg?x55086" alt="Brock University Logo" /></a>
      </div>
    </div>
    <AppMainNav />
  </div>
</template>

<script>
import AppMainNav from './AppMainNav';

export default {
  name: 'TopNavigation',
  components: {
    AppMainNav,
  },
};
</script>

<style lang="scss" scoped>
  @import '../assets/_colors.scss';
  @import '../assets/_globals.scss';

  .container{
    max-width: $container-width;
    width: 100%;
    margin-left: auto;
    margin-right: auto;
    padding-left: 1rem;
    padding-right: 1rem;
    box-sizing: border-box;
    display: flex;
    flex-direction: row;
  }

  .mobile-logo{
    height: $bar-height;
    display: none;
    align-items: center;

    @media screen and (max-width: $break-medium) {
      display: flex;
    }

    img{
      height: $bar-height - 10px;
      width: auto;
      padding: 0 .5rem;
    }

    h1{
      color: $white;
      margin: 0;
      flex: 1;
      font-size: 1.5rem;
    }
  }

  .left{
    display: flex;
    align-items: center;
  }

  .right{
    flex: 1;
    display: flex;
    justify-content: flex-end;
    align-items: center;

    &.hide-on-mobile{
      @media screen and (max-width: $break-small) {
        display: none;
      }
    }
  }

  a{
    color: $grey;
    padding: 0 .5rem;
  }

  h1{
    margin-left: 2rem;
    color: $red;
  }

  .desktop-logo{

    .logo {
      height: 150px;
      width: auto;
    }
    @media screen and (max-width: $break-medium) {
      display: none;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/TopNavigation.vue